import React from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const ToastCloseButton = ({ closeToast, type }) => (
  <IconButton
    onClick={closeToast}
    aria-label="Fechar notificação"
    size="small"
    sx={{
      // Same contrast color react-toastify uses for the message text on
      // this toast type (defined/overridden in toast.scss), so the close
      // icon always matches instead of duplicating the color here.
      color: `var(--toastify-text-color-${type}, #FFFFFF)`,
      // Bumps the clickable area to 32x32 without changing the icon's
      // visual size (fontSize: 18 below).
      width: "32px",
      height: "32px",
      padding: 0,
      alignSelf: "center",
    }}
  >
    <CloseIcon sx={{ fontSize: 18 }} />
  </IconButton>
);

export default ToastCloseButton;
